import { render } from "./memento_codes.vue?vue&type=template&id=64cf5692"
import script from "./memento_codes.vue?vue&type=script&lang=js"
export * from "./memento_codes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__